/**
 * watch: {
        textFieldValue() {
            this.$func.debounceMe(
                () => this.myCallBackFunc(), this
            );
        }
    },
 *
 * ==================
 *
 * Args:
 * 1. Callback function:
 *      What function is going to be called/debounced?
 *      {{ this.myCallBackFunc() }} in the example above.
 * 2. Context:
 *      The "this" of the component using the function.
 *      Just write the var {{ this }}, as in the example above.
 * 3. Custom property name:
 *      Type: string
 *      Only needed if you've got multiple uses of the debounceMe() function in the same component.
 *      If so, use this param to give each instance's timeouts custom names/keys.
 *      Or they'll really interfere with each other.
 * 4. Timeout value:
 *      Number of milliseconds to debounce by.
 *      Default 300.
 */

const debounceMe = (
    callbackFunc,
    context,
    customPropertyStr = 'Timeout',
    timeoutDuration = 300
) => {
    // add prefix to ensure we don't kill any reserved state items by accident
    const propertyStr = `vc4aDebounceMe${customPropertyStr}`;

    // If there's a debounce timeout already, clear it
    context[propertyStr] ? clearTimeout(context[propertyStr]) : null;

    // Reset debounce timer back to the start
    context[propertyStr] = setTimeout(() => {
        callbackFunc();
    }, timeoutDuration);
};

export default debounceMe;
